// ========================================
// These are exported only for use in other routes and tests!
// see the exported components and custom hooks for navigation!
// ========================================
export const idParamName = "id";
export const idPath = `:${idParamName}/`;
export const overviewPath = "overview/";
export const workspacePath = "workspace/";
export const workspaceOverviewRoute = `/${workspacePath}${idPath}${overviewPath}`;
